import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { PocComponent } from './poc/poc.component';
import {CognitoComponent} from './cognito/cognito.component';
import {CognitoutComponent} from './cognitout/cognitout.component';

const routes: Routes = [
  {
  path: '',
  children:
    [
      { path: '', component: HomeComponent },
      { path: 'poc', component: PocComponent },
      { path: 'publico/coordinador/sigin', component: CognitoComponent },
      { path: 'publico/coordinador/logout', redirectTo : '', component: CognitoutComponent }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicoRoutingModule { }
